import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 12,
    padding: theme.spacing(4),
    textAlign: 'center',
    maxWidth: 420,
  },
  icon: {
    fontSize: 56,
    color: theme.palette.type === 'dark' ? '#66bb6a' : '#2e7d32',
    marginBottom: theme.spacing(1),
  },
  score: {
    fontWeight: 700,
    marginTop: theme.spacing(1),
  },
  detail: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  button: {
    marginTop: theme.spacing(3),
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: theme.spacing(1, 4),
  },
}));

const TrainingCompleteModal = (props) => {
  const classes = useStyles();

  const pushToDashboard = () => {
    props.history.push({ pathname: '/Dashboard/TrainingDashboard' });
    window.scrollTo({ top: 110, left: 100, behavior: 'smooth' });
  };

  return (
    <Dialog
      onClose={props.toggle}
      aria-labelledby="Training Complete"
      open={props.modal}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <CheckCircleOutlineIcon className={classes.icon} />
      <Typography variant="h5" className={classes.score}>
        Training Complete
      </Typography>
      <Typography variant="h4" className={classes.score}>
        {props.scorePercentage}%
      </Typography>
      <Typography variant="body1" className={classes.detail}>
        You answered {props.correctAnswersCount} out of {props.quizLength} correctly.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={pushToDashboard}
        fullWidth
      >
        Return to Dashboard
      </Button>
    </Dialog>
  );
};

export default TrainingCompleteModal;
